import money from 'v-money'

export default ({ Vue }) => {
  Vue.use(money, {
    decimal: ',',
    thousands: '.',
    prefix: 'R$ ',
    suffix: '',
    precision: 2,
    masked: false
  })
}
